import { CheckPicker, mainColors, SNormal } from '@avantstay/backoffice-core'

import { CHANNEL_FILTER_OPTIONS } from '../../StayTimeline.consts'
import { ChannelTone } from '../../StayTimeline.types'
import * as S from './ChannelsFilter.styles'

interface ChannelsFilterProps {
  value: ChannelTone[]
  onChange: (channels: ChannelTone[]) => void
}

export const ChannelsFilter = ({ value, onChange }: ChannelsFilterProps) => {
  return (
    <S.Root>
      <SNormal color={mainColors.black}>Contact method</SNormal>

      <S.Picker>
        <CheckPicker.SmallNew
          className="channels-filter"
          options={CHANNEL_FILTER_OPTIONS}
          value={value}
          onChange={onChange}
          onClearSelection={() => onChange([])}
        />
      </S.Picker>
    </S.Root>
  )
}
